export default {
  getBusinessAddressById: state => businessAddressId => {
    return state.businessAddresses.find(
      businessAddress => businessAddress.id === businessAddressId
    );
  }
};
